import React, { useEffect } from 'react'
import {  Layout } from './Layout'
import { BreadCrumbProvider } from '../../component/ui/breadcrumb'
import { useDispatch, useSelector } from 'react-redux'

import { setInvestorInfo } from '../../context/actions/investorInfoAction'
import { getInvestorInfo, getSchemeInfoAgainstInvestor } from '../../utils/util'
import { setAllSchemeDetails } from '../../context/actions/allSchemeDetailsAction'
import { setSchemeInfoDetailsAgainstInvestor } from '../../context/actions/schemeInfoAgainstInvestorAction'
import { setAUMDataAgainstScheme } from '../../context/actions/aumDataAgainstSchemeAction'

const Investor = () => {

  const dispatch=useDispatch()
  const userInfo=useSelector(state=>state.user)
  const investorInfo=useSelector(state=>state.investorInfo)
  const handleGetInvestorInfo=async()=>{
    // dispatch(loaderSet(true))
    const payload={
      user_email:userInfo && userInfo?.email,
      user_type:userInfo &&  userInfo?.user_type,
      user_id:userInfo && userInfo?.user_id
    }
    try {
      const response=await getInvestorInfo(payload)
      console.log("response for handleGetInvestorInfo",response)
      if(response){
        dispatch(setInvestorInfo(response))
        // setScheme(response?.schemes.map((item,index)=>(`${item.scheme_name}-${item.scheme_class}`)))
        // if(scheme?.length>0){
        //   setSelectedSchemeOptions(scheme)
        //   console.log("setSelectedSchemeOptions(scheme)",scheme)

        // }
        
        // dispatch(loaderSet(false))
      }
    } catch (error) {
      console.log("Error in handleGetInvestorInfo function ",error)
      // dispatch(loaderSet(false))
    }
  }
  
  const handleGetSchemeDetailsAgainstInvestor=async()=>{
    if(investorInfo && investorInfo?.schemes){
       const payload={
      schemes:investorInfo.schemes
    }
    console.log(" handleGetSchemeDetailsAgainstInvestor",payload,investorInfo?.schemes)
    try {
     const response = await getSchemeInfoAgainstInvestor(payload)
     console.log("response for handleGetSchemeDetailsAgainstInvestor ",response)
     if(response){
      // dispatch(setAllSchemeDetails(response.data))
      dispatch(setSchemeInfoDetailsAgainstInvestor(response.data))
      dispatch(setAUMDataAgainstScheme(response.aumData))
     }
    } catch (error) {
      console.log("Error in handleGetSchemeDetailsAgainstInvestor function ",error)
    }
    }
   
    
  }

  useEffect(()=>{
    handleGetInvestorInfo()
    handleGetSchemeDetailsAgainstInvestor()
  },[])

  return (
    <>
    <BreadCrumbProvider>
    
    <Layout/>
    </BreadCrumbProvider>
    </>
  )
}

export default Investor